import { lazy } from 'react';
/** Открывает форму политики */
export const PolicyFormPageAsync = lazy(() => import('./PolicyForm/PolicyFormPage'));